module.exports = __webpack_public_path__ + "static/media/close-symbol-restaurant.7edbdf33.svg";